/**
 * @file
 */

export default (Drupal, once) => {

  // MARK: Pause animation
  // Stop CSS animation on window resize
  // https://css-tricks.com/stop-animations-during-window-resizing/
  Drupal.behaviors.pauseAnimation = {
    attach (context) {
      once('pause-animate', 'body', context).forEach(function () {
        let resizeTimer
        window.addEventListener('resize', () => {
          document.body.classList.add('resize-animation-stopper')
          clearTimeout(resizeTimer)
          resizeTimer = setTimeout(() => {
            document.body.classList.remove('resize-animation-stopper')
          }, 400)
        })
      })
    }
  }
}
